import React from 'react';
import { useQuery } from '@apollo/client';
import { getEquipCodes } from './api';

interface Props {
  // data: any;
  formik: any;
  disableFields: any;
}

const EquipCodeDropdown = (props: Props) => {
  const { loading, error, data } = useQuery(getEquipCodes);

  if (loading) return null;
  if (error) return <div>error</div>;

  if (props.formik.initialValues.status === 'Salvage Request') {
    return (
      <div className='form-group form-inline'>
        <label className='col-sm-3'>Equipment Status</label>
        <select
          className='form-control col-sm-8'
          id='equipmentStatus'
          name='equipmentStatus'
          disabled={props.disableFields}
          onChange={props.formik.handleChange}
          value={props.formik.values.equipmentStatus}
          defaultValue={1}>
          {data.readAllEquipmentCodes.map((status: any, index: number) => {
            return (
              <option key={index} value={status.EquipCodeId}>
                {status.Description}
              </option>
            );
          })}
        </select>
      </div>
    );
  }

  return null;
};

export default EquipCodeDropdown;
